var path = 'scripts/views/character-count.html';
var html = "<span class=\"help-block thick-dark-font em-bold small-font pull-right\"\n      ng-class=\"{ 'warning-font' : characterCount.isWarningLength(), 'danger-font' : characterCount.isDangerLength() }\">\n    {{ characterCount.charactersRemaining() }} <span translate>directives.characterCount.CharactersRemaining</span>\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/character-count.html
// module id = 290
// module chunks = 0